module.exports = __webpack_public_path__ + "img/login-img.b79e577f.png";